<template>
  <div class="content__details">
    <TheModal />
    <p>
      <button
        v-if="typeForfaitTransport !== null"
        @click="openForfaitResetModal()"
      >
        Supprimer l'ensemble des forfaits existants
      </button>
    </p>
  </div>
</template>

<script>
import TheModal from './modal/TheModal.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    TheModal
  },
  computed: {
    ...mapGetters([
      'typeForfaitTransport'
    ])
  },
  created() {
    this.$store.dispatch('initTypeForfaitTransport')
  },
  methods: {
    openForfaitTypeModal() {
      this.$store.dispatch('openForfaitTypeModal')
    },
    setTypeForfait(event) {
      this.$store.dispatch('setTypeForfait', event.target.value)
    },
    openForfaitResetModal() {
      this.$store.dispatch('openForfaitResetModal')
    }
  }
}
</script>
